<template>
  <div class="invoice">
    <div class="invoice_nav">
      <navbar
        title="发票账单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <van-row class="tips">
        <van-col span="24" class="title">开票说明</van-col>
        <van-col span="24" class="con"
          >1、次月1日生成上月的发票账单，请及时提交开票信息。</van-col
        >
        <van-col span="24" class="con">2、应开金额：该月份已提现金额</van-col>
        <van-col span="24" class="con"
          >3、已开金额：该月份已核销金额
          (提交的发票处于财务审核中时，不计入已开金额)</van-col
        >
      </van-row>
      <span class="search" @click="showDatePopup">
        <span>{{ selectData }}</span>
        <span class="icon"><van-icon name="play" /></span>
      </span>
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经是全部内容了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <van-row>
              <van-col span="24" class="money">
                {{ item.bill_date }}
                <span>账单ID：{{ item.id }}</span>
              </van-col>
              <van-col span="24" class="num"
                >应开金额：{{ item.payable_amount }}元</van-col
              >
              <van-col span="24" class="num"
                >已开金额：{{ item.opened_amount }}元</van-col
              >
              <van-col span="24" class="btns">
                <btn
                  v-if="item.opened_amount == 0"
                  :btntext="'提交开票信息'"
                  :btnwidth="'10.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#fff'"
                  :fontsize="'1.2rem'"
                  @btnClick="toConfirm(item)"
                />
                <btn
                  v-if="item.opened_amount != 0"
                  :btntext="'提交开票信息'"
                  :btnwidth="'10.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#E6E6E6'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#fff'"
                  :fontsize="'1.2rem'"
                />
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </van-pull-refresh>

      <van-row class="empty" v-if="list.length == 0 && !hasList">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>
      <div class="loading" v-if="list.length <= 0 && hasList">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>
      <van-popup v-model="showdate" position="bottom">
        <van-row class="title">
          <van-col span="12" :class="{ active: selectFirst }">
            <p class="decs">开始日期</p>
            <p>{{ startTime }}</p>
            <span></span>
          </van-col>
          <van-col span="12" :class="{ active: !selectFirst }">
            <p class="decs">结束日期</p>
            <p>{{ endTime }}</p>
            <span></span>
          </van-col>
        </van-row>
        <van-datetime-picker
          :formatter="formatter"
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :item-height="'5.1rem'"
          :visible-item-count="5"
          @change="changeTime($event)"
        />
        <p class="btns">
          <btn
            class="left"
            :btntext="'重置'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'#fff'"
            :borderradius="'0.4rem'"
            :btncolor="'#333'"
            :fontsize="'1.6rem'"
            :btnborder="'solid 0.05rem #ccc'"
            @btnClick="allTime"
          />
          <btn
            :btntext="selectFirst ? '下一步' : '确定'"
            :btnwidth="'16.6rem'"
            :height="'4.4rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'0.4rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            @btnClick="confirm"
          />
        </p>
      </van-popup>
    </div>
    <van-row class="btns_msg">
      <van-col span="12">
        <btn
          :btntext="'开票记录'"
          :btnwidth="'16.4rem'"
          :height="'4.4rem'"
          :bgcolor="'#FF9A00'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          :fontweight="700"
          :btnmargin="'0.4rem 0 0.4rem 1.6rem'"
          @btnClick="record"
        />
      </van-col>
      <van-col span="12">
        <btn
          :btntext="'开票资料'"
          :btnwidth="'16.4rem'"
          :height="'4.4rem'"
          :bgcolor="'#F41A3C'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          :fontweight="700"
          :btnmargin="'0.4rem 0 0.4rem 0.8rem'"
          @btnClick="invoiceMsg"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      // righticon: require("@/assets/purchaseSupplier/withdraw/invoiceRecord.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      showdate: false,
      selectData: "全部时间",
      startTime: "请选择",
      endTime: "请选择",
      currentDate: new Date(),
      minDate: new Date(2021, 0, 1),
      selectFirst: true,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    record() {
      this.$router.push("/purchaseSupplier/invoiceRecord");
    },
    toConfirm(item) {
      localStorage.setItem("billInfo", JSON.stringify(item));
      this.$router.push({
        path: "/purchaseSupplier/submitInvoice",
        query: {
          contract_type: this.$route.query.contract_type,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      let parm;
      if (this.selectData == "全部时间") {
        parm = {
          page: this.page,
        };
      } else {
        parm = {
          page: this.page,
          start_time: this.startTime,
          end_time: this.endTime,
        };
      }
      this.$api
        .post(
          "/member-relation/member/three/year/supplier/invoice-bill-list",
          parm
        )
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              if (res.list[i].bill_date)
                res.list[i].bill_date = this.formatDate(res.list[i].bill_date);
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    showDatePopup() {
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.selectFirst = true;
      this.currentDate = new Date();
      this.changeTime(this.currentDate);

      this.showdate = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    changeTime(value) {
      var year = this.currentDate.getFullYear();
      var month = this.currentDate.getMonth() + 1;
      if (this.selectFirst) {
        this.startTime = year + "-" + (month < 10 ? "0" + month : "" + month);
      } else {
        this.endTime = year + "-" + (month < 10 ? "0" + month : "" + month);
      }
    },
    confirm() {
      if (this.selectFirst) {
        this.selectFirst = false;
        this.changeTime(this.currentDate);
        return;
      }
      this.showdate = false;
      this.selectData =
        this.startTime.replace(/-/g, ".") +
        "-" +
        this.endTime.replace(/-/g, ".");
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    allTime() {
      this.showdate = false;
      this.selectData = "全部时间";
      this.startTime = "请选择";
      this.endTime = "请选择";
      this.page = 0;
      this.list = [];
      this.onLoad();
    },
    formatDate(date) {
      return date.slice(0, 4) + "." + date.slice(4, 6);
    },
    invoiceMsg() {
      this.$router.push({
        path: "/purchaseSupplier/invoiceMsg",
        query: {
          tax_type: this.$route.query.tax_type,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.invoice {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 8.8rem 0 5.5rem;
    box-sizing: border-box;
    height: 100%;

    .tips {
      padding: 2rem 1.6rem 0.8rem;

      .title {
        color: #333;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 2.1rem;
        margin-bottom: 1.5rem;
      }

      .con {
        color: #333;
        font-size: 1.2rem;
        line-height: 1.7rem;
        margin-top: 0.5rem;
      }
    }

    .search {
      height: 2.1rem;
      line-height: 2.1rem;
      padding: 0 1.6rem;
      color: #2c2c2f;
      font-size: 1.2rem;
      margin-top: 1.1rem;
      display: inline-block;

      span {
        float: left;
        .van-icon {
          margin-left: 0.7rem;
          width: 0.5rem;
          transform: translateY(-3px);
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg);
        }
      }

      .icon {
        margin-top: -0.2rem;
      }
    }

    .van-pull-refresh {
      height: calc(100% - 4.4rem);
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 13.1rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 2rem 1.6rem;
        box-sizing: border-box;

        .van-col {
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
        }

        .num {
          margin-bottom: 0.4rem;
        }

        .money {
          color: #333;
          font-size: 2rem;
          font-weight: 700;
          line-height: 2.8rem;
          margin-bottom: 0.8rem;

          span {
            float: right;
            color: #999;
            font-size: 1.2rem;
            font-weight: 400;
          }
        }

        .btns {
          text-align: right;
          margin-top: 0.8rem;
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }

    .van-popup {
      height: 43rem;

      .title {
        height: 8rem;

        .van-col {
          background: #f8f8f8;
          text-align: center;
          height: 8rem;

          p {
            color: #333;
            font-size: 1.4rem;
            line-height: 1.7rem;
          }

          .decs {
            color: #999;
            font-size: 1.2rem;
            margin: 1.8rem 0 0.6rem;
            line-height: 2rem;
          }
        }

        .active {
          background: #fff;

          span {
            display: block;
            width: 100%;
            height: 0.3rem;
            margin-top: 1.6rem;
            background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(to right, #fc740c, #f41a3c);
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #fc740c, #f41a3c);
          }
        }
      }

      /deep/.van-picker {
        height: 29rem;
        padding: 1.6rem 0;
        box-sizing: border-box;

        .van-picker__toolbar {
          display: none;
        }
      }

      .btns {
        padding-left: 1.6rem;

        .left {
          margin-right: 1.1rem;
        }
      }
    }
  }

  .btns_msg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
  }
}
</style>




